import React from 'react';
import {Flex} from '/app/src/component';
import Header from "./Header"
import FeatureList from "./FeatureList"

const bodyTextEmphasize = {
    color: "Black_M",
    hAlignContent: "center",
    width: "600px",
    fontSize: "20px",
    fontWeight: "500",
    marginTop: "10px"
}

const iconList = [
    "/images/Menu_Overview.svg",
    "/images/ResponseTime_S.svg",
    "/images/Download_M.svg",
    "/images/Menu_ClientChat_Helpdesk_L.svg"
]
const textList = [
    "Diagram med aktivitet och responstid.",
    "Mätning över tid (dygn, vecka, månad, år).",
    "Exportera CSV-filer.",
    "Statistik för Helpdesk feedback."
]

const StatisticsUpgrade = () => (
    <Flex column  hAlignContent="center" >
        <Flex>
            <Header
                icon={"/images/Upload.svg"}
                text={"Du har upptäckt en Pro-funktion!"}/>
        </Flex>
        <Flex {...bodyTextEmphasize}>
            Genom att uppgradera får du tillgång till utökad statistik.
        </Flex>
        <FeatureList
            iconList={iconList}
            textList={textList}/>
    </Flex>
)

export default StatisticsUpgrade;



// WEBPACK FOOTER //
// ./src/component/Modal/UpgradeModal/StatisticsUpgrade.js